import styled from '@emotion/styled';
import { Typography as _Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';

import ProductPricing from '../../../entity/ProductPricing';
import { SPACING_REGULAR } from '../../constant/spacing';
import mq from '../../styleUtility/mediaquery';

interface Props extends ClassAttributes<HTMLElement> {
  pointBalance: number;
  productPricing?: ProductPricing;
  className?: string;
}

const RequiredPointSummaryDescription = ({ pointBalance, productPricing, className }: Props) => {
  return (
    <Root className={className}>
      {productPricing && (
        <Column>
          {pointBalance > 0 ? (
            <Typography>
              <FormattedMessage
                id="required_point_summary_discription.about_point_balance"
                values={{
                  pointBalance: pointBalance.toLocaleString(),
                  pointBalancePrice:
                    productPricing.currency +
                    (pointBalance * productPricing.flatRate * (1 + productPricing.taxRate)).toLocaleString(),
                }}
              />
            </Typography>
          ) : null}
          <Typography>
            <FormattedHTMLMessage id="required_point_summary_discription.about_kaizen_point_detail" />
          </Typography>
        </Column>
      )}
    </Root>
  );
};

const Root = styled('div')(
  {
    paddingTop: SPACING_REGULAR,
    paddingBottom: SPACING_REGULAR,
  },
  {
    [mq('sp')]: {
      paddingTop: 0,
      paddingBottom: 0,
      marginRight: 0,
    },
  },
);

const Typography = styled(_Typography)({
  textAlign: 'right',
});
Typography.defaultProps = { variant: 'caption' };

const Column = styled('div')({
  marginTop: SPACING_REGULAR,
  textAlign: 'right',
});

export default RequiredPointSummaryDescription;
